import React from 'react';
import ClientAssessmentForm from './components/ClientAssessmentForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <ClientAssessmentForm />
    </div>
  );
}

export default App;
